module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_dolphin_laugh_002_25158.c2466516.mp3";